// extracted by mini-css-extract-plugin
module.exports = {"save":"product-category-modal_save_z6AWp"};